import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;
}

const NotYetVisitedDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('notYetVisitedTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <Typography className={classes.contentText}>{t('notYetVisitedIntro')}</Typography>
          <Stack component={'ul'} sx={{ pl: 2, m: 0 }} gap={1}>
            <Typography component={'li'} className={classes.contentText}>
              {t('notYetVisitedReason_not_reached')}
            </Typography>
            <Typography component={'li'} className={classes.contentText}>
              {t('notYetVisitedReason_limits')}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('close')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  contentText: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.text.primary,
  },
  italicNote: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default NotYetVisitedDialog;
